<template>
    <vx-box-glass class="text-slate-700 font-sans">
        <vx-wallpaper :icon="faNotebook"></vx-wallpaper>
        <div class="relative p-6 xl:p-10 max-w-2xl">
            <h2 class="mb-2 text-xl font-bold">
                Overview
                <font-awesome-icon widthAuto :icon="faTelescope"></font-awesome-icon>
            </h2>
            <p class="mb-2 text-base">
                A Campaign is a text or series of texts sent to a contact or
                audience based on a specific criteria. Send Campaigns to Tagged
                audiences until they perform a specific desired action over a
                period of time.
            </p>

            <p class="mb-2 text-base">
                Ex: Send 4 texts over a 7 day period to my “New Leads” Tagged
                contacts of 500 people. If a contact responds to a Campaign text
                stop sending any remaining texts in Campaign to that contact.
            </p>

            <a href="https://explore.voxie.com/voxiesupport/hc/en-us/articles/campaigns"
               target="_blank"
               rel="noopener noreferrer"
               class="text-sm font-sans font-normal text-sky-500 underline lg:text-base">
                See Docs for More
                <font-awesome-icon widthAuto class="ml-2"
                                   :icon="faArrowRightLong"></font-awesome-icon>
            </a>
        </div>
    </vx-box-glass>
</template>
<script setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faArrowRightLong } from '@fortawesome/pro-solid-svg-icons';
import { faTelescope, faNotebook } from "@fortawesome/pro-regular-svg-icons";
import { VxBoxGlass, VxWallpaper } from '@voxie/frontend-components';
</script>
